export interface HistoryEvent {
  statusEn: string;
  statusAr: string;
  date?: string;
  user?: string;
  action?: string;
  completed: boolean;
  actionRequired: boolean;
}
export const COMMENT_VISIBLE_STATUSES: string[] = [
  'accepted',
  'request approved',
  'rejected',
  'request rejected',
  'expired',
  'request expired',
  'cancelled',
  'request cancelled',
  'feedback needed',
  'request feedback',
];